import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'
import Messages from '@/helpers/message-helper'

import store from '@/store/index'

Vue.use(VueRouter)

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes,
	scrollBehavior: () => ({ x: 0, y: 0 })
})

// Check if next route requires auth, and handle accordingly
router.beforeResolve(async (to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		const { isAuthenticated, userRoles } = store.getters

		const accessRoleOk = to.matched.some(record => {
			// If accessRole is not set, only require authentication
			if (!record.meta.accessRole) return true
			return userRoles.includes(record.meta.accessRole)
		})

		// if user is not authenticated, redirect to home will occur
		if (isAuthenticated && accessRoleOk) {
			next()
		} else {
			Messages.showError('ACCESS DENIED')
			next({ path: '/' })
		}
	}

	next()
})

export default router